import React from 'react';
import TurtleEatingPlastic from '../../assets/turtle.png';
import {useTranslation} from "react-i18next";

function SaveThePlanet() {
    const {t} = useTranslation();

    return (
        <div style={{
            backgroundColor: '#EEEEEE',
            borderRadius: '12px',
            padding: '16px',
            display: 'flex',
            flexDirection: 'row',
        }}>
            {/* Container */}

            {/* First column */}
            <div style={{
                borderRadius: '12px',
            }}>
                <img src={TurtleEatingPlastic} alt="turtle eating plastic" style={{
                    maxWidth: '525px',
                    maxHeight: '150px',
                    objectFit: 'cover',
                    borderRadius: '12px',
                }}/>
            </div>

            {/* Second column */}
            <div style={{
                marginLeft: '12px',
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
            }}>
               <p style={{
                   fontWeight: 'bold',
                   fontSize: '19px'
               }}>{t('saving_the_planet_title')}</p>

                <p style={{
                    fontSize: '15px'
                }}>{t('saving_the_planet_description')}
                <a target="_blank" href={'https://www.allcolibri.com/impact/?p=misfits'} style={{color: '#00AB3A' }}>{t('learn_more')}</a>
                </p>
            </div>

        </div>
    )
}


export default SaveThePlanet
